document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initParallax();
  init3DScene();
  initTilt();
  initFaq();
  initMarquee();
  initStickyBar();
  initSpark();
  initMaskScroll();
  initProductGallery();
  initProductQty();
  initProductVariants();
  initRitualAddons();
  initBoxReveal();
  initReviewCarousel();
});

function initReviewCarousel() {
  var root = document.querySelector('.mt-res-carousel');
  if (!root) return;
  var viewport = root.querySelector('.mt-res-viewport');
  var track = root.querySelector('.mt-res-track');
  var originalCards = Array.prototype.slice.call(track.children);
  if (originalCards.length < 2) return; // nothing meaningful to loop

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    // Respect the user's preference: no auto-scroll, no drag loop gymnastics —
    // just let the track scroll natively like a normal horizontal list.
    viewport.style.overflowX = 'auto';
    track.style.width = 'max-content';
    return;
  }

  // Duplicate the set once so the loop has no visible seam.
  originalCards.forEach(function (card) {
    track.appendChild(card.cloneNode(true));
  });

  var halfWidth = 0;
  var cardStep = 0;
  function measure() {
    halfWidth = track.scrollWidth / 2;
    var first = track.children[0];
    var second = track.children[1];
    cardStep = second ? (second.offsetLeft - first.offsetLeft) : halfWidth;
  }
  measure();
  window.addEventListener('resize', measure);

  var pos = 0;
  var pxPerSecond = 16; // slow, premium pace
  var paused = false;
  var dragging = false;
  var dragStartX = 0;
  var dragStartPos = 0;
  var moved = false;
  var resumeTimer = null;

  function wrap(p) {
    if (halfWidth <= 0) return 0;
    p = p % halfWidth;
    if (p > 0) p -= halfWidth;
    return p;
  }
  function render() {
    track.style.transform = 'translate3d(' + pos + 'px,0,0)';
  }
  function scheduleResume() {
    clearTimeout(resumeTimer);
    resumeTimer = setTimeout(function () { paused = false; }, 2200);
  }

  var lastTs = null;
  function tick(ts) {
    if (lastTs === null) lastTs = ts;
    var dt = ts - lastTs;
    lastTs = ts;
    if (!paused && !dragging) {
      pos = wrap(pos - (pxPerSecond * dt) / 1000);
      render();
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  root.addEventListener('mouseenter', function () { paused = true; });
  root.addEventListener('mouseleave', function () { if (!dragging) paused = false; });

  function pointerX(e) {
    return e.touches ? e.touches[0].clientX : e.clientX;
  }
  function onPointerDown(e) {
    dragging = true;
    moved = false;
    paused = true;
    clearTimeout(resumeTimer);
    dragStartX = pointerX(e);
    dragStartPos = pos;
    track.classList.add('mt-res-dragging');
  }
  function onPointerMove(e) {
    if (!dragging) return;
    var dx = pointerX(e) - dragStartX;
    if (Math.abs(dx) > 4) moved = true;
    pos = wrap(dragStartPos + dx);
    render();
  }
  function onPointerUp() {
    if (!dragging) return;
    dragging = false;
    track.classList.remove('mt-res-dragging');
    scheduleResume();
  }

  viewport.addEventListener('mousedown', onPointerDown);
  window.addEventListener('mousemove', onPointerMove);
  window.addEventListener('mouseup', onPointerUp);
  viewport.addEventListener('touchstart', onPointerDown, { passive: true });
  viewport.addEventListener('touchmove', onPointerMove, { passive: true });
  viewport.addEventListener('touchend', onPointerUp);
  viewport.addEventListener('click', function (e) {
    if (moved) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  function step(dir) {
    pos = wrap(pos - dir * cardStep);
    render();
    paused = true;
    scheduleResume();
  }
  var prevBtn = root.querySelector('[data-res-prev]');
  var nextBtn = root.querySelector('[data-res-next]');
  if (prevBtn) prevBtn.addEventListener('click', function () { step(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { step(1); });

  viewport.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
  });
}

function initProductGallery() {
  var thumbs = document.querySelectorAll('.mt-prod-thumb');
  var mainImg = document.getElementById('mt-prod-main-img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      mainImg.src = t.dataset.full;
      thumbs.forEach(function (o) { o.classList.remove('mt-active'); });
      t.classList.add('mt-active');
    });
  });
}

function initBoxReveal() {
  var stage = document.querySelector('[data-mt-box]');
  if (!stage) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    stage.classList.add('mt-box-open');
    return;
  }

  var opened = false;
  stage.addEventListener('click', function () {
    opened = !opened;
    stage.classList.toggle('mt-box-open', opened);
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting && !opened) {
        opened = true;
        stage.classList.add('mt-box-open');
        io.unobserve(stage);
      }
    });
  }, { threshold: 0.55 });
  io.observe(stage);
}

function initRitualAddons() {
  var wrap = document.querySelector('[data-mt-addons]');
  var form = document.querySelector('.mt-prod-form');
  if (!wrap || !form) return;

  var priceEl = document.querySelector('.mt-prod-price');
  var basePrice = priceEl ? parseFloat(priceEl.dataset.mtBasePrice) || 0 : 0;
  var currencyCode = priceEl ? priceEl.dataset.mtCurrency : null;
  var chips = wrap.querySelectorAll('.mt-prod-addon-chip');
  var selected = []; // {id, price}

  var fmt = null;
  if (currencyCode) {
    try { fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: currencyCode }); } catch (e) { fmt = null; }
  }

  function updatePrice() {
    var total = basePrice + selected.reduce(function (sum, s) { return sum + s.price; }, 0);
    if (!priceEl) return;
    priceEl.textContent = fmt ? fmt.format(total) : total.toFixed(2);
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var id = chip.dataset.addonVariant;
      var price = parseFloat(chip.dataset.addonPrice) || 0;
      var idx = selected.findIndex(function (s) { return s.id === id; });
      if (idx > -1) {
        selected.splice(idx, 1);
        chip.classList.remove('mt-active');
      } else {
        selected.push({ id: id, price: price });
        chip.classList.add('mt-active');
      }
      updatePrice();
    });
  });

  form.addEventListener('submit', function (e) {
    if (!selected.length) return; // no add-ons chosen: let the form submit natively
    e.preventDefault();

    var addBtn = form.querySelector('.mt-prod-add');
    var addText = document.getElementById('mt-prod-add-text');
    var originalText = addText ? addText.textContent : '';
    if (addBtn) addBtn.setAttribute('disabled', 'disabled');
    if (addText) addText.textContent = 'Adding...';

    var mainId = document.getElementById('mt-prod-variant-id').value;
    var qty = parseInt(form.querySelector('.mt-prod-qty-input').value, 10) || 1;
    var items = [{ id: mainId, quantity: qty }];
    selected.forEach(function (s) {
      items.push({ id: s.id, quantity: qty });
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        window.location.href = '/cart';
      })
      .catch(function () {
        if (addBtn) addBtn.removeAttribute('disabled');
        if (addText) addText.textContent = originalText;
        alert('Something went wrong adding your ritual to the cart. Please try again.');
      });
  });
}

function initProductQty() {
  var form = document.querySelector('.mt-prod-form');
  if (!form) return;
  var input = form.querySelector('.mt-prod-qty-input');
  var minus = form.querySelector('[data-qty-minus]');
  var plus = form.querySelector('[data-qty-plus]');
  if (!input || !minus || !plus) return;
  minus.addEventListener('click', function () {
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
  });
  plus.addEventListener('click', function () {
    input.value = (parseInt(input.value, 10) || 1) + 1;
  });
}

function initProductVariants() {
  var form = document.querySelector('.mt-prod-form');
  if (!form) return;
  var selects = form.querySelectorAll('.mt-prod-option-select');
  var variantScript = form.querySelector('[data-mt-variants]');
  if (!selects.length || !variantScript) return;
  var variants;
  try { variants = JSON.parse(variantScript.textContent); } catch (e) { return; }
  var idInput = document.getElementById('mt-prod-variant-id');
  var priceEl = document.querySelector('.mt-prod-price');
  var addBtn = document.querySelector('.mt-prod-add');
  var addText = document.getElementById('mt-prod-add-text');

  function currentSelection() {
    return Array.from(selects).map(function (s) { return s.value; });
  }
  function moneyFormat(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function update() {
    var sel = currentSelection();
    var match = variants.find(function (v) {
      return sel.every(function (val, i) { return v.options[i] === val; });
    });
    if (!match) return;
    idInput.value = match.id;
    if (priceEl && typeof match.price !== 'undefined') {
      priceEl.textContent = moneyFormat(match.price);
    }
    if (addBtn) {
      if (match.available === false) {
        addBtn.setAttribute('disabled', 'disabled');
        if (addText) addText.textContent = 'Sold out';
      } else {
        addBtn.removeAttribute('disabled');
        if (addText) addText.textContent = addBtn.dataset.label || addText.textContent;
      }
    }
  }
  selects.forEach(function (s) { s.addEventListener('change', update); });
}

function initMaskScroll() {
  var section = document.getElementById('mt-mask-scroll');
  if (!section) return;
  var steps = section.querySelectorAll('.mt-mscroll-step');
  var visual = section.querySelector('.mt-mscroll-visual');
  var panels = section.querySelectorAll('.mt-mscroll-panel');
  var dots = section.querySelectorAll('.mt-mscroll-dot');
  if (!steps.length || !visual) return;

  function setActive(i) {
    visual.setAttribute('data-active', i);
    panels.forEach(function (p) { p.classList.toggle('mt-active', Number(p.dataset.panel) === i); });
    dots.forEach(function (d) { d.classList.toggle('mt-active', Number(d.dataset.dot) === i); });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) setActive(Number(entry.target.dataset.step));
    });
  }, { threshold: 0.5 });
  steps.forEach(function (s) { io.observe(s); });
}

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) { els.forEach(function (el) { el.classList.add('mt-visible'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16 });
  els.forEach(function (el) { io.observe(el); });
}

function initParallax() {
  var els = document.querySelectorAll('.mt-parallax');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    var vh = window.innerHeight;
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var center = rect.top + rect.height / 2;
      var progress = (center - vh / 2) / vh;
      var intensity = parseFloat(el.dataset.mtIntensity || '18');
      var rotate = parseFloat(el.dataset.mtRotate || '0');
      var t = 'translateY(' + (progress * intensity) + 'px)';
      if (rotate) t += ' rotate(' + (progress * rotate) + 'deg)';
      el.style.transform = t;
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

function init3DScene() {
  var scenes = document.querySelectorAll('.mt-3d-scene');
  if (!scenes.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function update() {
    scenes.forEach(function (scene) {
      var stage = scene.querySelector('.mt-3d-stage');
      if (!stage) return;
      var rect = scene.getBoundingClientRect();
      var vh = window.innerHeight;
      var progress = 1 - Math.min(Math.max((rect.top) / (vh * 0.9), 0), 1);
      var rotate = -26 + progress * 26;
      var translate = 40 - progress * 40;
      stage.style.transform = 'perspective(1200px) rotateY(' + rotate + 'deg) rotateX(4deg) translateY(' + translate + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
  update();
}

function initTilt() {
  var cards = document.querySelectorAll('.mt-tilt');
  if (!cards.length) return;
  if (window.matchMedia('(hover: none)').matches) return;
  cards.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.transform = 'perspective(900px) rotateY(' + (x * 10) + 'deg) rotateX(' + (y * -10) + 'deg) translateY(-4px)';
    });
    card.addEventListener('mouseleave', function () {
      card.style.transform = 'perspective(900px) rotateY(0) rotateX(0) translateY(0)';
    });
  });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.mt-faq-q');
    var ans = item.querySelector('.mt-faq-a');
    if (!btn || !ans) return;
    btn.addEventListener('click', function () {
      var open = item.classList.contains('mt-open');
      items.forEach(function (i) {
        i.classList.remove('mt-open');
        var a = i.querySelector('.mt-faq-a');
        if (a) a.style.maxHeight = '';
      });
      if (!open) {
        item.classList.add('mt-open');
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });
}

function initStickyBar() {
  var bar = document.querySelector('.mt-stickybar');
  var trigger = document.querySelector('.mt-combo');
  if (!bar || !trigger) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('mt-show', entry.boundingClientRect.top < 0 && !entry.isIntersecting);
    });
  }, { threshold: 0 });
  io.observe(trigger);
  window.addEventListener('scroll', function () {
    var rect = trigger.getBoundingClientRect();
    bar.classList.toggle('mt-show', rect.bottom < 0);
  }, { passive: true });
}

function initSpark() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('.mt-btn-primary').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var count = 10;
      for (var i = 0; i < count; i++) {
        var spark = document.createElement('span');
        spark.className = 'mt-spark';
        var angle = (Math.PI * 2 * i) / count;
        var dist = 40 + Math.random() * 30;
        spark.style.left = e.clientX + 'px';
        spark.style.top = e.clientY + 'px';
        spark.style.setProperty('--mt-sx', Math.cos(angle) * dist + 'px');
        spark.style.setProperty('--mt-sy', Math.sin(angle) * dist + 'px');
        document.body.appendChild(spark);
        (function (el) { setTimeout(function () { el.remove(); }, 650); })(spark);
      }
    });
  });
}

function initMarquee() {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.mt-marquee-track').forEach(function (track) {
    if (track.dataset.mtDup) return;
    track.dataset.mtDup = '1';

    var viewport = track.parentElement;

    if (reduceMotion || track.children.length < 2) {
      viewport.style.overflowX = 'auto';
      return;
    }

    track.innerHTML += track.innerHTML;

    var halfWidth = 0;
    function measure() { halfWidth = track.scrollWidth / 2; }
    measure();
    window.addEventListener('resize', measure);

    var pos = 0;
    var pxPerSecond = 14; // slow, ambient drift
    var paused = false;

    function wrap(p) {
      if (halfWidth <= 0) return 0;
      p = p % halfWidth;
      if (p > 0) p -= halfWidth;
      return p;
    }

    var lastTs = null;
    function tick(ts) {
      if (lastTs === null) lastTs = ts;
      var dt = ts - lastTs;
      lastTs = ts;
      if (!paused) {
        pos = wrap(pos - (pxPerSecond * dt) / 1000);
        track.style.transform = 'translate3d(' + pos + 'px,0,0)';
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);

    viewport.addEventListener('mouseenter', function () { paused = true; });
    viewport.addEventListener('mouseleave', function () { paused = false; });
  });
}
